import { Component, Input } from '@angular/core';
import { Table } from '@shared/models';

@Component({
  selector: 'sp-details-table',
  templateUrl: './details-table.component.html',
  styleUrls: ['./details-table.component.scss'],
})
export class DetailsTableComponent {
  activeStatus = 1;
  @Input() table: Table;
}
